function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFD300;}\n\t.st1{fill:#FF9100;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Rettangolo_80_00000036242439412570790030000012066051759144080287_"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M3.6,0h38.2c2,0,3.6,1.6,3.6,3.5v29.3c0,1.9-1.6,3.5-3.6,3.5H3.6c-2,0-3.6-1.6-3.6-3.5V3.5C0,1.6,1.6,0,3.6,0 z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_246_00000145033038066364197710000002209230524865734806_",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tracciato_82_00000101080203311692953090000005337875262839120055_"
}, /*#__PURE__*/React.createElement("rect", {
  x: 21.6,
  className: "st1",
  width: 2,
  height: 36.1
})), /*#__PURE__*/React.createElement("g", {
  id: "Tracciato_83_00000011746542748914954570000007606158392626814127_"
}, /*#__PURE__*/React.createElement("rect", {
  x: 22.7,
  y: 17.5,
  className: "st1",
  width: 11.4,
  height: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Tracciato_85_00000045599397368447851560000012006077587802741684_"
}, /*#__PURE__*/React.createElement("rect", {
  x: 33.9,
  y: 10.1,
  className: "st1",
  width: 11.4,
  height: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Tracciato_87_00000078010157262043589190000001973006607899392678_"
}, /*#__PURE__*/React.createElement("rect", {
  x: 33.9,
  y: 24.9,
  className: "st1",
  width: 11.4,
  height: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Tracciato_86_00000114778238156539659180000009826295852125954748_"
}, /*#__PURE__*/React.createElement("rect", {
  x: 11.2,
  y: 10.1,
  className: "st1",
  width: 11.4,
  height: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Tracciato_88_00000022533305629213837130000014226108089862062509_"
}, /*#__PURE__*/React.createElement("rect", {
  x: 11.2,
  y: 24.9,
  className: "st1",
  width: 11.4,
  height: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Tracciato_84_00000020395665646778659150000016199564100892091538_"
}, /*#__PURE__*/React.createElement("rect", {
  y: 17.5,
  className: "st1",
  width: 11.4,
  height: 2
}))));

function SvgChip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45.3 36.3",
    style: {
      enableBackground: "new 0 0 45.3 36.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.85d04c9c.svg";
export { ForwardRef as ReactComponent };